// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  background: #0a0a0a;
  color: #ffffff;
}

.App.admin-shell-context,
.admin-layout {
  --admin-shell-max: clamp(1360px, 94vw, 1880px);
  --admin-shell-pad-x: clamp(16px, 1.35vw, 32px);
  --admin-shell-pad-y: clamp(14px, 1.2vw, 24px);
  --admin-compact-shell-pad-y: clamp(12px, 1vw, 18px);
  --admin-tool-canvas-height: calc(100vh - 52px - 32px);
}

.admin-layout {
  min-height: 100vh;
  width: 100%;
}

.admin-layout > * {
  min-width: 0;
}

.admin-layout :is(
  .diff-review-page,
  .admin-validation-page,
  .admin-question-validation-page,
  .cv-page,
  .admin-bug-reports,
  .admin-storage-drugs-page,
  .admin-storage-uploads-page,
  .admin-training-page,
  .admin-feedback-dashboard,
  .ars-page,
  .ih-page,
  .api-logs-page,
  .admin-settings-page,
  .admin-panel,
  .au-page,
  .reservoir-page,
  .elo-page,
  .admin-standardize-page,
  .admin-spot-check-page,
  .dc-page,
  .admin-proposals-page,
  .abq-page,
  .si-container,
  .admin-test-pages,
  .adp-container,
  .adp-session-wrapper,
  .qp-page,
  .dialysis-preview,
  .cram-map-proposal,
  .cram-proposal-b,
  .cram-proposal-c,
  .admin-concept-test,
  .admin-algo-test,
  .mc-container,
  .bp-container,
  .dlv2-container,
  .cls-preview-container,
  .bl-setup
) {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: var(--admin-shell-pad-y) var(--admin-shell-pad-x);
  min-height: auto;
  background: transparent;
  box-sizing: border-box;
}

.admin-layout :is(
  .uploads-table-container,
  .api-logs-table-wrap,
  .au-table-wrap,
  .cypher-table-container,
  .cls-lb-wrapper
) {
  width: 100%;
  overflow-x: auto;
}

.admin-layout :is(
  .uploads-table,
  .api-logs-table,
  .au-table,
  .cypher-results-table,
  .cls-lb-table
) {
  min-width: 1100px;
}

/* Hide app chrome while the welcome modal is active. */
body.welcome-active .top-nav,
body.welcome-active .bottom-left-stack,
body.welcome-active .admin-subbar {
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Unified loading shell — shown during auth resolution.
   Matches the final page background so the transition is seamless.
   Spinner fades in after 400ms to avoid flash on fast connections. */
.app-loading-shell {
  min-height: 100vh;
  background: var(--bg-base, #0a0a0a);
}

.app-workspace-shell {
  min-height: 100vh;
  min-width: 0;
}

.app-workspace-shell--scaled {
  transform-origin: top left;
}

/* ============================================================
   Viewport-modal backdrop-filter flicker guard.
   Full rationale lives in components/BossMapModal/BossMapModal.css
   (Edward, 2026-06-20). Short version: every map-viewport modal lays a
   \`backdrop-filter: blur()\` scrim over the LIVE dashboard (orb tray spin,
   infinite pulse animations). Chrome re-rasterizes the blur on every frame the
   content behind it repaints, and intermittently DROPS the blur for a frame —
   flashing the sharp map through the modal ("the combat modal flickers,
   revealing the map behind"). Pausing every animation OUTSIDE the open modal
   makes the backdrop static so Chrome caches the blur layer and never
   re-rasters. Blurred-and-paused is visually identical (you can't perceive
   motion through a 4px blur); the modal's own subtree keeps animating. The
   below-map concept carousel is outside the scrim, so its track is exempt.

   BossMapModal keeps its own co-located copy of this rule; this block covers
   the sibling viewport modals that never got the 2026-06-20 fix (the "every so
   often" flicker Edward still saw was these paths). ADD ANY NEW map-viewport
   overlay class to this list so a future modal can't reintroduce the flicker.
   ============================================================ */
body:has(.mcp-overlay) *:not(.mcp-overlay):not(.mcp-overlay *):not(.cards-carousel-track),
body:has(.dmm-overlay) *:not(.dmm-overlay):not(.dmm-overlay *):not(.cards-carousel-track),
body:has(.crmm-overlay) *:not(.crmm-overlay):not(.crmm-overlay *):not(.cards-carousel-track),
body:has(.gvm-overlay) *:not(.gvm-overlay):not(.gvm-overlay *):not(.cards-carousel-track) {
  animation-play-state: paused !important;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #0a0a0a;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* Shared styles for main content area */
.main-content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 3rem 2rem;
}

.main-content h2 {
  color: #ffffff;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.main-content p {
  color: #9ca3af;
  font-size: 1.1rem;
  line-height: 1.6;
}

@media (max-width: 1600px), (max-height: 940px) {
  .App.admin-shell-context,
  .admin-layout {
    --admin-shell-max: min(96vw, 1720px);
    --admin-shell-pad-x: clamp(14px, 1.15vw, 24px);
    --admin-shell-pad-y: clamp(12px, 1vw, 18px);
    --admin-compact-shell-pad-y: clamp(10px, 0.85vw, 16px);
    --admin-tool-canvas-height: calc(100vh - 48px - 24px);
  }
}

@media (min-width: 2400px) {
  .App.admin-shell-context,
  .admin-layout {
    --admin-shell-max: min(96vw, 2280px);
    --admin-shell-pad-x: clamp(24px, 1.4vw, 40px);
    --admin-shell-pad-y: clamp(16px, 1vw, 28px);
    --admin-compact-shell-pad-y: clamp(14px, 0.9vw, 20px);
    --admin-tool-canvas-height: calc(100vh - 56px - 36px);
  }
}

/* Bottom-left stack: shared portal column for the BLS rail and related overlays.
   All children share 240px width and the stack grows upward as content adds. */
.bottom-left-stack {
  position: fixed;
  bottom: var(--space-6);
  left: var(--space-6);
  z-index: var(--z-fab, 900);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-2);
  pointer-events: none;
  width: 240px;
}

.bottom-left-stack > * {
  pointer-events: auto;
}

/* Confirmation Dialog */
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.confirm-dialog {
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem 2rem;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.confirm-dialog h3 {
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
}

.confirm-dialog p {
  color: #9ca3af;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0 0 1.5rem 0;
}

.confirm-dialog-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.confirm-dialog-btn {
  padding: 0.65rem 1.25rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirm-dialog-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.confirm-dialog-btn-cancel {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.confirm-dialog-btn-cancel:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
}

.confirm-dialog-btn-danger {
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #f87171;
}

.confirm-dialog-btn-danger:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.3);
  border-color: rgba(239, 68, 68, 0.5);
}

/* Global Suspense loading spinner */
.suspense-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
}

.suspense-spinner::after {
  content: '';
  width: 36px;
  height: 36px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: suspense-spin 0.8s linear infinite;
}

@keyframes suspense-spin {
  to { transform: rotate(360deg); }
}

/* ── Compression progress overlay ── */
.compress-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.compress-modal {
  background: #1a1a2e;
  border: 1px solid rgba(102, 126, 234, 0.3);
  border-radius: 12px;
  padding: 28px 36px;
  min-width: 320px;
  max-width: 400px;
  text-align: center;
}

.compress-label {
  font-size: 13px;
  color: #b0b0cc;
  margin-bottom: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.compress-bar-track {
  height: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 3px;
  overflow: hidden;
}

.compress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.compress-pct {
  font-size: 12px;
  color: #667eea;
  margin-top: 10px;
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,8CAA8C;EAC9C,8CAA8C;EAC9C,6CAA6C;EAC7C,mDAAmD;EACnD,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,WAAW;EACX,eAAe;EACf,SAAS;EACT,0DAA0D;EAC1D,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;;;EAOE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,iBAAiB;AACnB;;AAEA,uDAAuD;AACvD;;;EAGE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;qEAEqE;AACrE;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;;;iEAkBiE;AACjE;;;;EAIE,uCAAuC;AACzC;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,oCAAoC;IACpC,8CAA8C;IAC9C,2CAA2C;IAC3C,sDAAsD;IACtD,qDAAqD;EACvD;AACF;;AAEA;EACE;;IAEE,oCAAoC;IACpC,6CAA6C;IAC7C,2CAA2C;IAC3C,qDAAqD;IACrD,qDAAqD;EACvD;AACF;;AAEA;+EAC+E;AAC/E;EACE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC","sourcesContent":[".App {\n  min-height: 100vh;\n  background: #0a0a0a;\n  color: #ffffff;\n}\n\n.App.admin-shell-context,\n.admin-layout {\n  --admin-shell-max: clamp(1360px, 94vw, 1880px);\n  --admin-shell-pad-x: clamp(16px, 1.35vw, 32px);\n  --admin-shell-pad-y: clamp(14px, 1.2vw, 24px);\n  --admin-compact-shell-pad-y: clamp(12px, 1vw, 18px);\n  --admin-tool-canvas-height: calc(100vh - 52px - 32px);\n}\n\n.admin-layout {\n  min-height: 100vh;\n  width: 100%;\n}\n\n.admin-layout > * {\n  min-width: 0;\n}\n\n.admin-layout :is(\n  .diff-review-page,\n  .admin-validation-page,\n  .admin-question-validation-page,\n  .cv-page,\n  .admin-bug-reports,\n  .admin-storage-drugs-page,\n  .admin-storage-uploads-page,\n  .admin-training-page,\n  .admin-feedback-dashboard,\n  .ars-page,\n  .ih-page,\n  .api-logs-page,\n  .admin-settings-page,\n  .admin-panel,\n  .au-page,\n  .reservoir-page,\n  .elo-page,\n  .admin-standardize-page,\n  .admin-spot-check-page,\n  .dc-page,\n  .admin-proposals-page,\n  .abq-page,\n  .si-container,\n  .admin-test-pages,\n  .adp-container,\n  .adp-session-wrapper,\n  .qp-page,\n  .dialysis-preview,\n  .cram-map-proposal,\n  .cram-proposal-b,\n  .cram-proposal-c,\n  .admin-concept-test,\n  .admin-algo-test,\n  .mc-container,\n  .bp-container,\n  .dlv2-container,\n  .cls-preview-container,\n  .bl-setup\n) {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: var(--admin-shell-pad-y) var(--admin-shell-pad-x);\n  min-height: auto;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.admin-layout :is(\n  .uploads-table-container,\n  .api-logs-table-wrap,\n  .au-table-wrap,\n  .cypher-table-container,\n  .cls-lb-wrapper\n) {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.admin-layout :is(\n  .uploads-table,\n  .api-logs-table,\n  .au-table,\n  .cypher-results-table,\n  .cls-lb-table\n) {\n  min-width: 1100px;\n}\n\n/* Hide app chrome while the welcome modal is active. */\nbody.welcome-active .top-nav,\nbody.welcome-active .bottom-left-stack,\nbody.welcome-active .admin-subbar {\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n/* Unified loading shell — shown during auth resolution.\n   Matches the final page background so the transition is seamless.\n   Spinner fades in after 400ms to avoid flash on fast connections. */\n.app-loading-shell {\n  min-height: 100vh;\n  background: var(--bg-base, #0a0a0a);\n}\n\n.app-workspace-shell {\n  min-height: 100vh;\n  min-width: 0;\n}\n\n.app-workspace-shell--scaled {\n  transform-origin: top left;\n}\n\n/* ============================================================\n   Viewport-modal backdrop-filter flicker guard.\n   Full rationale lives in components/BossMapModal/BossMapModal.css\n   (Edward, 2026-06-20). Short version: every map-viewport modal lays a\n   `backdrop-filter: blur()` scrim over the LIVE dashboard (orb tray spin,\n   infinite pulse animations). Chrome re-rasterizes the blur on every frame the\n   content behind it repaints, and intermittently DROPS the blur for a frame —\n   flashing the sharp map through the modal (\"the combat modal flickers,\n   revealing the map behind\"). Pausing every animation OUTSIDE the open modal\n   makes the backdrop static so Chrome caches the blur layer and never\n   re-rasters. Blurred-and-paused is visually identical (you can't perceive\n   motion through a 4px blur); the modal's own subtree keeps animating. The\n   below-map concept carousel is outside the scrim, so its track is exempt.\n\n   BossMapModal keeps its own co-located copy of this rule; this block covers\n   the sibling viewport modals that never got the 2026-06-20 fix (the \"every so\n   often\" flicker Edward still saw was these paths). ADD ANY NEW map-viewport\n   overlay class to this list so a future modal can't reintroduce the flicker.\n   ============================================================ */\nbody:has(.mcp-overlay) *:not(.mcp-overlay):not(.mcp-overlay *):not(.cards-carousel-track),\nbody:has(.dmm-overlay) *:not(.dmm-overlay):not(.dmm-overlay *):not(.cards-carousel-track),\nbody:has(.crmm-overlay) *:not(.crmm-overlay):not(.crmm-overlay *):not(.cards-carousel-track),\nbody:has(.gvm-overlay) *:not(.gvm-overlay):not(.gvm-overlay *):not(.cards-carousel-track) {\n  animation-play-state: paused !important;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0a0a0a;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n/* Shared styles for main content area */\n.main-content {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 3rem 2rem;\n}\n\n.main-content h2 {\n  color: #ffffff;\n  margin-bottom: 1rem;\n  font-size: 2rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.main-content p {\n  color: #9ca3af;\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n@media (max-width: 1600px), (max-height: 940px) {\n  .App.admin-shell-context,\n  .admin-layout {\n    --admin-shell-max: min(96vw, 1720px);\n    --admin-shell-pad-x: clamp(14px, 1.15vw, 24px);\n    --admin-shell-pad-y: clamp(12px, 1vw, 18px);\n    --admin-compact-shell-pad-y: clamp(10px, 0.85vw, 16px);\n    --admin-tool-canvas-height: calc(100vh - 48px - 24px);\n  }\n}\n\n@media (min-width: 2400px) {\n  .App.admin-shell-context,\n  .admin-layout {\n    --admin-shell-max: min(96vw, 2280px);\n    --admin-shell-pad-x: clamp(24px, 1.4vw, 40px);\n    --admin-shell-pad-y: clamp(16px, 1vw, 28px);\n    --admin-compact-shell-pad-y: clamp(14px, 0.9vw, 20px);\n    --admin-tool-canvas-height: calc(100vh - 56px - 36px);\n  }\n}\n\n/* Bottom-left stack: shared portal column for the BLS rail and related overlays.\n   All children share 240px width and the stack grows upward as content adds. */\n.bottom-left-stack {\n  position: fixed;\n  bottom: var(--space-6);\n  left: var(--space-6);\n  z-index: var(--z-fab, 900);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--space-2);\n  pointer-events: none;\n  width: 240px;\n}\n\n.bottom-left-stack > * {\n  pointer-events: auto;\n}\n\n/* Confirmation Dialog */\n.confirm-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.confirm-dialog {\n  background: #1a1a1a;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.5rem 2rem;\n  max-width: 420px;\n  width: 90%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.confirm-dialog h3 {\n  color: #ffffff;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 0.75rem 0;\n}\n\n.confirm-dialog p {\n  color: #9ca3af;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin: 0 0 1.5rem 0;\n}\n\n.confirm-dialog-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.confirm-dialog-btn {\n  padding: 0.65rem 1.25rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirm-dialog-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.confirm-dialog-btn-cancel {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n.confirm-dialog-btn-cancel:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.confirm-dialog-btn-danger {\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  color: #f87171;\n}\n\n.confirm-dialog-btn-danger:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.3);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n/* Global Suspense loading spinner */\n.suspense-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  width: 100%;\n}\n\n.suspense-spinner::after {\n  content: '';\n  width: 36px;\n  height: 36px;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: suspense-spin 0.8s linear infinite;\n}\n\n@keyframes suspense-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Compression progress overlay ── */\n.compress-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.compress-modal {\n  background: #1a1a2e;\n  border: 1px solid rgba(102, 126, 234, 0.3);\n  border-radius: 12px;\n  padding: 28px 36px;\n  min-width: 320px;\n  max-width: 400px;\n  text-align: center;\n}\n\n.compress-label {\n  font-size: 13px;\n  color: #b0b0cc;\n  margin-bottom: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.compress-bar-track {\n  height: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.compress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.compress-pct {\n  font-size: 12px;\n  color: #667eea;\n  margin-top: 10px;\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
